import React from 'react';
import { ReactQueryConfigProvider } from 'react-query';
import { queryConfig } from './queryConfig';

export const App = ({ children }) => {
  return (
    <ReactQueryConfigProvider config={queryConfig}>
      <div className="app">
        <div className="app-cont">{children}</div>
      </div>
    </ReactQueryConfigProvider>
  );
};
